import React from 'react';
import { Card, Descriptions, Row, Col, Statistic } from 'antd';
import { UserOutlined, AppstoreOutlined, SafetyOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { useAuth } from '../../context/AuthContext';
import './index.css';

const Home = () => {
  const { user } = useAuth();

  return (
    <div className="home-page">
      <h1 style={{ marginBottom: 24 }}>欢迎回来</h1>
      
      {/* 统计卡片 */}
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic
              title="已注册应用"
              value={12}
              prefix={<AppstoreOutlined />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="在线用户"
              value={156}
              prefix={<UserOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="今日登录"
              value={1234}
              prefix={<ClockCircleOutlined />}
              valueStyle={{ color: '#cf1322' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="安全等级"
              value="高"
              prefix={<SafetyOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Card>
        </Col>
      </Row>

      {/* 用户信息 */}
      <Card title="用户信息" style={{ marginBottom: 24 }}>
        <Descriptions bordered column={2}>
          <Descriptions.Item label="用户名">
            {(user && typeof user === 'object' && 'username' in user) ? user.username : '-'}
          </Descriptions.Item>
          <Descriptions.Item label="姓名">
            {(user && typeof user === 'object' && 'name' in user) ? user.name : '-'}
          </Descriptions.Item>
          <Descriptions.Item label="邮箱">
            {(user && typeof user === 'object' && 'email' in user) ? user.email : '-'}
          </Descriptions.Item>
          <Descriptions.Item label="角色">
            {(user && typeof user === 'object' && 'role' in user) ? user.role : '管理员'}
          </Descriptions.Item>
          <Descriptions.Item label="最后登录时间">
            {(user && typeof user === 'object' && 'lastLoginTime' in user) ? user.lastLoginTime : '-'}
          </Descriptions.Item>
          <Descriptions.Item label="状态">
            <span style={{ color: '#52c41a' }}>正常</span>
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </div>
  );
};

export default Home;
